import styled, { css } from 'styled-components'

// Components
import { TableComponents, Skeleton } from '@sketch/components'

export const Wrapper = styled.div<{ hasFadedBottom?: boolean }>`
  position: relative;
  margin-top: 24px;

  ${({ hasFadedBottom, theme }) =>
    hasFadedBottom &&
    css`
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 150px;
        background: linear-gradient(
          to top,
          ${theme.colors.foreground.primary.B},
          transparent
        );
      }
    `}
`
export const SkeletonAvatar = styled(Skeleton)`
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  margin-right: 8px;
  border-radius: ${({ theme }) => theme.radii.rounded};
`

export const StyledTableRow = styled(TableComponents.TableRow)`
  display: flex;
`

export const StyledLoadingTableCell = styled(TableComponents.TableCell)`
  display: inline-flex;
  align-items: center;
  flex: 1;

  :nth-child(2) {
    justify-content: center;
  }

  :last-child {
    justify-content: flex-end;
  }
`
